import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Login from './Login';
import { History } from 'history';
import { LOGIN_PATH } from '../../constants';

export default () => (
    <Switch>
        <Route
            path={`${LOGIN_PATH}/reset/:token?`}
            component={({ history, match }: { history: History, match: { params: { token: string } } }) => <Login reset={true} history={history} match={match} />}
        />
        <Route
            path={`${LOGIN_PATH}/:token?`}
            component={({ history, match }: { history: History, match: { params: { token: string } } }) => <Login history={history} match={match} />}
        />
        <Route
            exact
            path="/"
            component={({ history }: { history: History }) => <Login history={history} />}
        />
    </Switch>
);



// WEBPACK FOOTER //
// ./src/client/login/index.tsx